import { RAW_COLORS } from '../colors';

export const DIVIDER_THEME = {
  color: {
    default: RAW_COLORS.bluegray150,
    weak: RAW_COLORS.bluegray100,
    strong: RAW_COLORS.bluegray200,
    circle: RAW_COLORS.bluegray400,
  },
};